import { useEffect, useState, FunctionComponent } from 'react';
import { FormControlLabel } from '../../tailwindcomponents';
import { Button, Checkbox, Dialog } from '../../tailwindcomponents';
import { BasicCalendar } from '../../components';
import VacationApi from './../../api/vacation';
import { CalendarVacationCell, ShiftLocation } from '../../types/vacation';
import { Typography, Input, Snackbar, Select, Table, TableRow, TableCell } from '../../tailwindcomponents';
import { VacationRequest } from './../../types/vacation';
import { Datepicker } from '@mobiscroll/react';
import { vacationCategories } from './../../properties/vacationProperties';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';

type VacationCalendarProps = {
  setLoading: Function;
  selectedLocation: string;
  selectedCategory: string;
  handleCategoryChange: Function;
  handleLocationChange: Function;
}

const VacationCalendar: FunctionComponent<VacationCalendarProps> = ({ setLoading, selectedLocation, selectedCategory, handleCategoryChange, handleLocationChange}) => {
  const [eventsEmployeeVacations, setEventsEmployeeVacations] = useState(Array<CalendarVacationCell>());
  const [departmentTypesOfVacation, setDepartmentTypesOfVacation] = useState(Array<VacationRequest>());
  const [applyForVacationDialogOpen, setApplyForVacationDialogOpen] = useState(false);
  const [cellDialogOpen, setCellDialogOpen] = useState(false);
  const [selectedDates, setSelectedDates] = useState<Date[]>([new Date(), new Date()]);
  const [mechanicReason, setMechanicReason] = useState("");
  const [allLocations, setAllLocations] = useState(Array<string>);
  const [halfDayChecked, sethalfDayChecked] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"error" | "success">("success");

  
  const categoryList = Object.keys(vacationCategories);

  useEffect(() => {
    if (allLocations.length === 0) {
      VacationApi.GetAllVacationLocations().then(res => {
        setAllLocations(res.data.map((location: ShiftLocation) => location.location));
      });
    }
    if (selectedLocation !== "") {
      setLoading(true);
      VacationApi.GetAllVacationEventsForCalendar(selectedLocation).then(res => {
        setEventsEmployeeVacations(res.data);
        setLoading(false);
      });
    }
  }, [selectedLocation, applyForVacationDialogOpen, selectedDates, halfDayChecked]);

  const generateTableBody = (row: VacationRequest, index: number) => {
    const statusColor = row.status === "Approved" ? "text-green-600" : "text-orange-500";
    return (
      <TableRow>
        <TableCell>{index}</TableCell>
        <TableCell>{row.created_date_text}</TableCell>
        <TableCell>{row.department_name}</TableCell>
        <TableCell>{row.created_by_employee_name}</TableCell>
        <TableCell className={statusColor}>{row.status}</TableCell>
      </TableRow>
    )
  }

  const onCloseApplyForVacationDialog = (status: boolean) => {
    if (status === true && selectedLocation !== "") {
      VacationApi.CreateVacationRequest(selectedDates[0]!, selectedDates[1]!, mechanicReason, selectedLocation, halfDayChecked).then(res => {
        if (res.status === true) {
          setApplyForVacationDialogOpen(false);
          sethalfDayChecked(false);
          setSnackbarSeverity("success");
        } else {
          setSnackbarSeverity("error");
        }
        setSnackbarMessage(res.message || "");
      });
    }
    else {
      setApplyForVacationDialogOpen(false);
    }
  }
  const onEventClick = (event: CalendarVacationCell) => {
    VacationApi.GetVacationForTheDayByStartTime(event.start, selectedLocation).then(res => {
      if (res.status === true) {
        setCellDialogOpen(true);
        setDepartmentTypesOfVacation(res.data);
      }
    });
  }
  const onDateChange = (ev: any) => {
    setSelectedDates(ev.value);
  };
  return (
    <div>
      <Select
        options={categoryList.map(category => category)}
        selectedItem={selectedCategory}
        widthPercentage
        width={20}
        onSelectedItem={(e: React.ChangeEvent<HTMLSelectElement>) => {
          handleCategoryChange(e.target.value);
        }}
        filter_by_text="Select Unit"
      />
      <Select
        options={
          vacationCategories[selectedCategory]
            ? vacationCategories[selectedCategory].map(location => location)
            : []
        }
        selectedItem={selectedLocation ?? ""}
        widthPercentage
        width={20}
        onSelectedItem={(e: React.ChangeEvent<HTMLSelectElement>) => {
          handleLocationChange(e.target.value);
        }}
        filter_by_text="Select Work location"
      />
      {
        selectedLocation !== "" ?
          <div>
            <Typography align='center' text={selectedLocation} variant='h2' />
            {
              selectedLocation === "Bay" ?
                <Typography align='center' text={"11 employees per shift"} variant='h3' />
                :
                <Typography align='center' text={"1 employee per shift "} variant='h3' />
            }
            <div className="flex flex-wrap content-center justify-center">
              <Button variant="contained" color='primary' className="mb-2" onClick={(e: any) => setApplyForVacationDialogOpen(true)}>APPLY FOR LEAVE</Button>
            </div>
            <br />
            <BasicCalendar defaultView='month' events={eventsEmployeeVacations} resizableEvent={false} onEventClick={(e: CalendarVacationCell) => onEventClick(e)} />
          </div>
          :
          <div>
            <Typography text={"Please select workstation"} align='center' variant='h2' />
          </div>
      }
      <Dialog
        visible={applyForVacationDialogOpen}
        max_width={"sm"} title={"Select date range for your vacation request"}
        context={
          <div className="w-full flex flex-wrap justify-center">
            <Datepicker
              controls={['calendar']}
              select="range"
              inRangeInvalid={true}
              value={selectedDates}
              onChange={(el: any) => onDateChange(el)}
            />
            <FormControlLabel
              control={<Checkbox color="primary" disabled={selectedDates[0]?.getDate() === selectedDates[1]?.getDate() ? false : true} checked={halfDayChecked} onChange={() => { sethalfDayChecked(!halfDayChecked) }} />}
              label="Half day"
            />
            <Input multiline={true} help_text={"[Optional] "} error={false} label_text={"Add comment"} value={mechanicReason} onTextChange={(text: string) => setMechanicReason(text)} type="text" width={60} />
          </div>
        }
        onClose={(status: any) => onCloseApplyForVacationDialog(status)}
        strict={false}
        show_options={true}
        cancelText="Cancel"
      />
      <Dialog
        visible={cellDialogOpen}
        max_width={"sm"} title={"Types of vacation for this day"}
        context={
          <div className="w-full flex flex-wrap justify-center">
            <Table
              headers={["Created date", "Department", "Employee", "Status"]}
              rows={departmentTypesOfVacation}
              generateBody={(row: any, index: number) => generateTableBody(row, index)}
              defaultRowsPerPage={25}
            />
          </div>
        }
        onClose={(status: boolean) => setCellDialogOpen(false)}
        strict={false}
        show_options={false}
        cancelText="Cancel"
      />
      <Snackbar onSnackBarClose={() => setSnackbarMessage("")} open={(snackbarMessage ?? "").length > 0} message={snackbarMessage ?? ""} autoHide={true} severity={snackbarSeverity} horizontalPosition='right' />
    </div>
  );
}
export default VacationCalendar;